import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertSku from "../../../components/skuComponent/insertSku";
import { translate } from "react-i18next";

class AddSku extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "add_title",
      editData: {},
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
    }
  }

  onFormSubmit = () => {
    this.props.history.push("/product");
    this.props.history.go();
  };
  render() {
    return (
      <React.Fragment>
        <AddTitleBar Title={this.props.t(this.state.title)} LinkName="/product" />
        <div className="m-2">
          <InsertSku
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default translate("sku")(AddSku);
